import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const YukonIcon = (props: BaseProvinceIconProps) => {
  return (
    <path
      id="YT"
      {...props}
      d="M34.7,90.6c0.3,0,0.6,0.1,1,0.4c0.6,0.5,1.2,0.9,1.8,1.3c1.9,1.3,3,2.5,2.4,5.2
        c-0.8,3.1-1.8,12.3-2.3,16.6c-0.2,1.5,0,3.1,0.3,4.6c2.2,8.1,9.8,36,13.3,48.2c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.6-0.3,1-0.8,1
        c-0.1,0-0.2,0-0.4-0.1c-15.8-8.1-31.3-16-46.9-24c-0.8-0.4-1.1-1.4-0.7-2.2l0.1-0.2c10.2-16.8,20.4-33.6,30.6-50.4
        C33.8,91,34.2,90.6,34.7,90.6L34.7,90.6z"
    />
  );
};
